export const NULL_ADDRESS = '0x0000000000000000000000000000000000000000';
export const NATIVE_TOKEN_ADDRESS = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';

// We do not list the following tokens in the tokens package because they are not meant to be listed
// on Venus. TODO: remove these once the tokens have been unlisted from contracts
export const BSC_MAINNET_UNLISTED_TOKEN_ADDRESSES = [
  '0x20bff4bbEDa07536FF00e073bd8359E5D80D733d', // CAN
  '0x3d4350cD54aeF9f9b2C29435e0fa809957B3F30a', // UST
  '0x156ab3346823B651294766e23e6Cf87254d68962', // LUNA
];

export const BSC_TESTNET_UNLISTED_TOKEN_ADDRESSES = [
  '0x5A79efD958432E72211ee73D5DDFa9bc8f248b5F', // UST
  '0xf36160EC62E3B191EA375dadfe465E8Fa1F8CabB', // LUNA
];
